'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
require('@emotion/react');
require('../../../../../../node_modules/@fortawesome/react-fontawesome/index.es.cjs');
require('../../../../../../_virtual/index.cjs');
require('react');
require('@remix-run/react');
require('react-router-dom');
require('../../../utils/AviaryProvider/AviaryThemeContext.cjs');
require('../../../../../../_virtual/index2.cjs');
require('aviary-tokens');
require('../../atoms/Typography/Typography.web.cjs');
var InternalToggle_web = require('../../internal/InternalToggle/InternalToggle.web.cjs');

/**
 * A UI control that allows users to toggle a single setting on or off
 *
 * {@link https://aviary.fullscript.io/latest/components/toggle/web-RD2MToIP | Documentation}
 *
 * {@link https://git.fullscript.io/developers/aviary/-/blob/development/packages/aviary-web/src/components/molecules/Toggle/Toggle.web.tsx | View in GitLab}
 *
 * @scope Core
 */ const Toggle = ({ ...props })=>{
    return /*#__PURE__*/ jsxRuntime.jsx(InternalToggle_web.InternalToggle, {
        ...props
    });
};
Toggle.displayName = "Toggle";

exports.Toggle = Toggle;
//# sourceMappingURL=Toggle.web.cjs.map
